<script>
import texts from '../assets/data/localisations.json'

export default {
  data() {
    return {
      texts: null,
    }
  },
  computed: {
    // two way bound
    searchQuery: {
      get() {
        return this.$store.getters['topics/searchValue']
      },
      set(value) {
        this.$store.dispatch('topics/updateSearchValue', value)
      },
    },
    unreadMessages() {
      return this.$store.getters['globals/unread']
    },
    // method to get initial and filtered users lsit
    backButton() {
      if (this.$router.currentRoute.name !== 'faq') {
        return true
      }
      return false
    },
    locale() {
      return this.$store.getters['globals/locale']
    },
    getTitle() {
      if (this.$router.currentRoute.name === 'contact') {
        return this.texts[this.locale].contact
      } else if (this.$router.currentRoute.name === 'faq') {
        return this.texts[this.locale].topics
      } else if (this.$router.currentRoute.name === 'discord-consent') {
        return "Discord Consent"
      } else {
        return this.texts[this.locale].help
      }
    },
  },
  created() {
    this.texts = texts
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    }
  },
}
</script>

<template>
  <md-toolbar class="md-primary navigation-toolbar">
    <md-button v-if="backButton" :class="['back-button', 'md-primary']" @click="goBack">
      <svg class="md-icon" fill="#ffffff" xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 -960 960 960" width="48"><path fill="" d="m315-433 232 232-67 66-345-345 345-346 67 67-232 232h511v94H315Z"></path></svg>
    </md-button>
    <span class="md-title">{{ getTitle }}</span>

    <div class="md-toolbar-section-end">
      <div v-if="$router.currentRoute.name === 'faq'" class="searchbar">
        <md-field md-inline>
          <label>{{ texts[locale].searchtopics }}</label>
          <md-input v-model="searchQuery"></md-input>
          <md-button class="md-icon-button">
            <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M795.761-114.304 531.326-378.5q-29.761 25.264-69.6 39.415-39.84 14.15-85.161 14.15-109.835 0-185.95-76.195Q114.5-477.326 114.5-585t76.196-183.87q76.195-76.195 184.369-76.195t183.87 76.195q75.695 76.196 75.695 184.02 0 43.328-13.641 82.97-13.641 39.641-40.924 74.402L845.5-164.043l-49.739 49.739ZM375.65-393.065q79.73 0 135.29-56.245Q566.5-505.554 566.5-585t-55.595-135.69q-55.595-56.245-135.255-56.245-80.494 0-136.757 56.245Q182.63-664.446 182.63-585t56.228 135.69q56.227 56.245 136.792 56.245Z"/></svg>
          </md-button>
        </md-field>
      </div>
      <div class="nav-spacer"></div>
    </div>
  </md-toolbar>
</template>

<style lang="scss">
.navigation-toolbar {
  position: fixed !important;
  z-index: 1000 !important;
  top: 0;
  left: 0;
  width: 100%;
  padding: env(safe-area-inset-top) 0 0 0;

  .md-field:before {
    background: none !important;
  }
}

.back-button {
  min-width: 30px !important;
}

.searchbar {
  height: 50px;
  display: flex;

  .md-field {
    width: 162px;
    margin-top: 6px !important;
    margin-bottom: 8px !important;
    padding-top: 0px !important;
    background: #fff;
    min-height: 30px;
    height: 38px;
    border-radius: 20px;
    overflow: hidden;

    &:after {
      background: none !important;
      height: 0 !important;
    }

    label {
      position: absolute;
      top: 10px;
      left: 10px;
    }

    input {
      width: 100px;
      margin-top: 3px;
      margin-left: 15px;
    }
  }

  .md-icon-button {
    margin-bottom: 0px;
    margin-top: 0px;
    margin-left: 0px;

    .md-icon {
      color: #000 !important;
    }
  }
}

.ar .searchbar .md-field {
  width: 160px;
}

.ar .searchbar .md-field label {
  left: auto;
  right: 10px;
  font-size: 14px !important;
}

.pt .searchbar .md-field label {
  font-size: 11px;
}

.ru .searchbar .md-field {
  width: 180px;
}

.ru .searchbar .md-field input {
  width: 120px;
}

.md-field.md-inline.md-focused label {
  top: 36px !important;
}

.nav-spacer {
  width: 50px;
}

.ar .navigation-toolbar,
.ar .navigation-toolbar .md-toolbar-section-end {
  direction: ltr;
}

.ar .navigation-toolbar * {
  direction: rtl;
}

@media (max-width: 960px) {
  .appcontainer {
    min-height: calc(100vh - 48px);
  }
}

@media (max-width: 600px) {
  .appcontainer {
    min-height: calc(100vh - 56px);
  }
}

@media screen and (min-width: 760px) {
  .appcontainer {
    min-height: calc(100vh - 100px);
  }

  .navigation-toolbar {
    min-height: 100px !important;
  }

  .searchbar {
    height: 60px;
    margin-top: 0 !important;

    .md-field {
      width: 300px;
      height: 50px;
      border-radius: 25px;

      input {
        height: 45px;
      }

      label {
        top: 15px;
        left: 20px;
      }
    }

    .md-icon-button {
      margin-top: 6px !important;
    }
  }

  .nav-spacer {
    width: 100px;
  }

  .md-field.md-inline.md-focused label {
    top: 46px !important;
  }

  .ru .searchbar .md-field {
    width: 200px;
  }

  .ru .searchbar .md-field input {
    width: 120px;
  }
}
</style>
